/**
 * NOTE: This is generated file any changes to it can be overwritten at some point
 */
import React from 'react';

import { createSvgIcon } from '../utils';

const ClosedCaptioningIcon = /*#__PURE__*/ createSvgIcon(
  'ClosedCaptioningIcon',
  {
    ltr: {
      large: ({ id }) => (
        <>
          <path
            d="M3.333 16.667c-.458 0-.85-.164-1.177-.49A1.605 1.605 0 011.666 15V5c0-.458.164-.85.49-1.177.327-.326.72-.49 1.177-.49h13.334c.458 0 .85.164 1.177.49.326.326.49.719.49 1.177v10c0 .458-.164.85-.49 1.177-.327.326-.719.49-1.177.49H3.333zm0-1.667h13.334V5H3.333v10zm2.5-1.667h5c.236 0 .434-.08.594-.24.16-.159.24-.357.24-.593a.806.806 0 00-.24-.594.807.807 0 00-.594-.24h-5a.806.806 0 00-.593.24.806.806 0 00-.24.594c0 .236.08.434.24.594.16.16.357.24.593.24zM9.167 10h5c.236 0 .434-.08.594-.24.16-.16.24-.357.24-.593a.806.806 0 00-.24-.594.806.806 0 00-.594-.24h-5a.806.806 0 00-.594.24.806.806 0 00-.24.594c0 .236.08.434.24.593.16.16.358.24.594.24zm-3.334 0c.237 0 .434-.08.594-.24.16-.16.24-.357.24-.593a.806.806 0 00-.24-.594.806.806 0 00-.594-.24.806.806 0 00-.593.24.806.806 0 00-.24.594c0 .236.08.434.24.593.16.16.357.24.593.24zm8.334 3.333c.236 0 .434-.08.594-.24.16-.159.24-.357.24-.593a.806.806 0 00-.24-.594.806.806 0 00-.594-.24.806.806 0 00-.594.24.806.806 0 00-.24.594c0 .236.08.434.24.594.16.16.358.24.594.24z"
            fill="currentColor"
          />
        </>
      ),
    },
  },
  false
);

export default ClosedCaptioningIcon;
